import styled from 'styled-components';

export const CardsBox = styled.div`
  display: flex;
`;
